import { render, staticRenderFns } from "./AuthorizedRatifierAuthorize.vue?vue&type=template&id=54081874"
import script from "./AuthorizedRatifierAuthorize.vue?vue&type=script&lang=js"
export * from "./AuthorizedRatifierAuthorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports